import React from 'react';

export default function PaginationTips({ current = 1, pageSize = 10 }) {
  if (current * pageSize < 10000) return null;
  return (
    <p
      style={{
        textAlign: 'right',
        paddingRight: '30px',
        color: 'rgba(0, 0, 0, 0.45)',
      }}
    >
      更多数据请精确搜索
    </p>
  );
}

export function totalCount(total = 0) {
  return total >= 10000 ? 10000 : total;
}
